import React from 'react'

import Leaflet from 'leaflet'
import { createControlComponent } from "@react-leaflet/core"
import "leaflet-routing-machine"

import './OrderCurrent.scss'
import 'leaflet/dist/leaflet.css'

import { Link } from 'react-router-dom'

import iconUrl from '../../../assets/svg/Location.svg'

import DeliveryIcon from '../../../assets/svg/PeykProfileIcon.svg'
import PeykProfileIcon from '../../../assets/svg/PeykProfile.svg'
import PeykMenuOrderActive from '../../../assets/svg/PeykMenuOrder-mini-active.svg'
import PeykMenuAnalytic from '../../../assets/svg/PeykMenuAnalytic-mini.svg'
import PeykMenuMessage from '../../../assets/svg/PeykMenuMessage-mini.svg'
import PeykMenuOrderDone from '../../../assets/svg/PeykMenuOrderDone-mini.svg'
import PeykHat from '../../../assets/svg/PeykHat-mini.svg'

import { MapContainer, TileLayer } from 'react-leaflet'
export const newicon = new Leaflet.Icon({
  iconUrl,
  iconAnchor: [5, 55],
  popupAnchor: [10, -44],
  iconSize: [45, 55]
})

Leaflet.Marker.prototype.options.icon = newicon

const createRoutineMachineLayer = (props) => {
  const instance = Leaflet.Routing.control({
    waypoints: [
      Leaflet.latLng(37.27579, 49.937),
      Leaflet.latLng(37.27579, 49.957)
    ],
    lineOptions: {
      styles: [{ color: "#6FA1EC", weight: 4 }]
    },
    show: false,
    addWaypoints: false,
    routeWhileDragging: true,
    draggableWaypoints: false,
    fitSelectedRoutes: true,
    showAlternatives: true,
  })
  return instance;
}

const RoutingMachine = createControlComponent(createRoutineMachineLayer)

export default function index() {
  return (
    <div id='peyk'>
      <header className='header'>
        <section className='header__name'>
          <div>
            <img src={DeliveryIcon} alt="DeliveryIcon" />
          </div>
          <div className='profileName'>
            <span className='profileName__self'>
              محمد خوشه چین
            </span>
            <span className='profileName__tag'>
              سفیر کانولی
            </span>
          </div>
        </section>
        <section className='header__profile'>
          <Link to='/#'>
            <img src={PeykProfileIcon} alt="PeykProfileIcon" />
          </Link>
        </section>
      </header>
      <main className='body current__page'>
        <div className="body__title">
          سفارشات جاری
        </div>
        <div className="current">
          <div className="current__text">
            <span>محمد خوشه چین</span>
            <hr />
            <span>
              آدرس : گیلان، آستانه اشرفیه، آقا سید حسن، کرم،
              آستانه اشرفیه 
            </span>
          </div>
          <div className="current__map">
            <MapContainer
              doubleClickZoom={false}
              id="mapId"
              zoom={14}
              center={[33.5024, 36.2988]}
            >
              <TileLayer
                attribution='&amp;copy <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
                url="https://{s}.tile.osm.org/{z}/{x}/{y}.png"
              />
              <RoutingMachine />
            </MapContainer>
          </div>
          <div className="current__button">
            <button>تحویل داده شد</button>
          </div>
        </div>
      </main>
      <nav className='navbar'>
        <Link to='/peyk/current' className='navbar__item'>
          <span>
            <img src={PeykMenuOrderActive} alt="PeykMenuOrderActive" />
          </span>
          <span className='navbar__item--active'>
            سفارشات
          </span>
        </Link>
        <Link to='/peyk/analytic' className='navbar__item'>
          <span>
            <img src={PeykMenuAnalytic} alt="PeykMenuAnalytic" />
          </span>
          <span>
            حسابداری
          </span>
        </Link>
        <Link to='/peyk/dashboard' className='navbar__item'>
          <span>
            <img src={PeykHat} alt="PeykHat" />
          </span>
          <span>
            سفیر
          </span>
        </Link>
        <Link to='/peyk/messages' className='navbar__item'>
          <span>
            <img src={PeykMenuMessage} alt="PeykMenuMessage" />
          </span>
          <span>
            پیام‌ها
          </span>
        </Link>
        <Link to='/peyk/orders' className='navbar__item'>
          <span>
            <img src={PeykMenuOrderDone} alt="" />
          </span>
          <span>
            انجام شده
          </span>
        </Link>
      </nav>
    </div>
  )
}
